module.exports = __webpack_public_path__ + "img/156.dcda23be.jpg";